import { useTranslation } from 'react-i18next';
import CableIcon from '@mui/icons-material/Cable';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import PieChartIcon from '@mui/icons-material/PieChart';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import { MenuItem } from '..';
import { NeedsPermission } from '../../security';
import { UserPermission } from '../../enums';

export const CorporateUserMenu = () => {
  const { t } = useTranslation();

  return (
    <>
      <MenuItem
        title={t('navigation.dashboard')}
        icon={<DashboardIcon />}
        to="/corporate-user/dashboard"
      />

      <NeedsPermission
        oneOf={[
          UserPermission.ManageCorporateCustomerReservations,
          UserPermission.ManageOwnReservations,
        ]}
      >
        <MenuItem
          title={t('navigation.reservations')}
          icon={<HourglassTopIcon />}
          to="/corporate-user/reservations"
          match="corporate-user/reservations/*"
        />
      </NeedsPermission>

      <NeedsPermission
        oneOf={[
          UserPermission.RequestQuotes,
          UserPermission.ViewCorporateQuotes,
        ]}
      >
        <MenuItem
          title={t('navigation.quotes')}
          icon={<RequestQuoteIcon />}
          to="/corporate-user/quotes"
          match="corporate-user/quotes/*"
        />
      </NeedsPermission>

      <NeedsPermission oneOf={[UserPermission.ViewOrders]}>
        <MenuItem
          title={t('navigation.orders')}
          icon={<FolderOpenIcon />}
          to="/corporate-user/orders"
          match="corporate-user/orders/*"
        />
      </NeedsPermission>

      <NeedsPermission oneOf={[UserPermission.ViewInventory]}>
        <MenuItem
          title={t('navigation.inventory')}
          icon={<CableIcon />}
          to="/corporate-user/inventory"
          match="/corporate-user/inventory/*"
        />
      </NeedsPermission>

      <NeedsPermission
        oneOf={[
          UserPermission.ViewReservationConversionRatesReports,
          UserPermission.ViewQuoteReports,
        ]}
      >
        <MenuItem
          title={t('navigation.reports')}
          icon={<PieChartIcon />}
          to="/corporate-user/reports/conversion-rate"
          match="/corporate-user/reports/*"
        />
      </NeedsPermission>

      <MenuItem
        title={t('navigation.tutorials')}
        icon={<PlayCircleOutlineOutlinedIcon />}
        to="/corporate-user/tutorials"
        match="corporate-user/tutorials/*"
      />
    </>
  );
};
